/* @flow */
import { ChartModel } from './chart.model';
import { formatDateWithYear } from './utils/date.utils';
import { EventTarget } from './utils/event-target';

export class Header extends EventTarget {
    chart: ChartModel;
    container: HTMLElement;
    text: string;
    dates: HTMLElement;
    constructor (container: HTMLElement, chart: ChartModel, text: string) {
        super();
        this.text = text;
        this.chart = chart;
        this.container = container;
        this._render();
    }

    _render () {
        const header = document.createElement('div');
        header.className = 'header';
        const headerText = document.createElement('h3');
        headerText.className = 'header-text';
        headerText.textContent = this.text;
        this.dates = document.createElement('h4');
        this.dates.className = 'header-dates';
        this.dates.textContent = this.formatDates();
        header.appendChild(headerText);
        header.appendChild(this.dates);
        this.container.appendChild(header);
    }

    formatDates () {
        const from = this.chart.row.data[this.chart.selectStart];
        const to = this.chart.row.data[this.chart.selectEnd - 1];
        return formatDateWithYear(from) + ' - ' + formatDateWithYear(to);
    }

    update (from, to) {
        this.dates.textContent = this.formatDates();
    }
}
